import "../../assets/style/main.css";
import "./style.scss"
import { useEffect, useRef, useState } from "react";
import $ from 'jquery'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
const MySwal = withReactContent(Swal)
import { EncryptedOBJ, DecryptedOBJ, EncryptedText, DecryptedText } from "../../utils/Encryption";
import moment from "moment";
import { Base_API } from "../../_actions/matcher";
import PageLoader from "../../components/PageLoader";
import { isPageLoading } from "../../components/PageLoader";
import SignIn_Navbar from "../../components/SignIn_Navbar";
import ARROW_DOWN_ICON from '../../assets/images/icons/arrow-b.png'
import Breadcrumb_Step from "../../components/Breadcrumb_Step";
import { NhealthAction } from "../../_actions/action.api";
import { JWTAuthen, getHeadersAuthenLineId } from "../../_actions/sso.authen";
import ContentLoader, {isContentLoading} from "../../components/ContentLoader";

export default function KYC_Step_3() {
    let onceMount = useRef(true);
    const DOB_DAY = useRef(null);
    const INPUT_COMPANY = useRef(null); 
    const INPUT_COMPANY_ADDRESS = useRef(null);
    const INPUT_OCCUPATION = useRef(null);
    const INPUT_OCCUPATION_OTHER = useRef(null);
    const INPUT_INCOME = useRef(null);
    const INPUT_PROVINCE = useRef(null);
    const INPUT_DISTRICT = useRef(null);
    const INPUT_SUBDISTICT = useRef(null);
    const INPUT_POSTCODE = useRef(null);

    useEffect(() => {
        if (onceMount.current) {
            pageInit();
            onceMount.current = false;
        }
    }, []);

    let ddDays = ['ไทย']

    const [formData, setFormData] = useState({
        card_id: "",
        passport: "",
        fullname_th: "",
        fullname_en: "",
        dob: "",
        gender: "",
        age: 0,
        phone: "",
        email: "",
        company_name: "",
        company_address: "",
        other_occupation: "",
        address: ""
    });
    // const [isOpen, setIsOpen] = useState(false);
    const [errorMsg, setErrorMsg] = useState({
        idcard: "",
        passport: "",
        fullname_th: "",
        fullname_en: "",
        gender: "",
        age: "",
        tel: "",
        email: "",
        company_name: "",
        company_address: "",
        other_occupation: "",
        address: ""
    });
    const [lang, setLang] = useState('th');
    const [OccupationDD, setOccupationDD] = useState(null);
    const [otherOccupation, setOtherOccupatin] = useState(false);
    const [incomPerMonthDD, setIncomePerMonthDD] = useState(null);
    const [provinceDD, setProvinceDD] = useState(null);
    const [districtDD, setDistrictDD] = useState(null);
    const [subDistrictDD, setSubDistrictDD] = useState(null);
    const [postCodeDD, setPostCodeDD] = useState(null);


    const pageInit = async () => {
        await dropdownInit();
        checkCurrentURL();

        isPageLoading(false);
    };

    const checkCurrentURL = () => {
        let pathname = location.pathname;
        localStorage.setItem(process.env.REACT_APP_ENCNAME_CURRENTPAGEURL, EncryptedText(pathname));
        localStorage.setItem(process.env.REACT_APP_ENCNAME_CAMEFROM_URL, EncryptedText(pathname));
    }

    function dropdownInit() {
        return new Promise(async resolve => {
            // let jwtData = await JWTAuthen(); // sso
            // let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
            // let udid = lineProfile.user_id;
            // let headers = {
            //     token: jwtData.token,
            //     userRef: udid,
            //     authorizeRef: jwtData.authorizeRef,
            //     channalRef: jwtData.channalRef
            // }

            await getOccupation(); 
            await getIncomPerMonth(); 
            await getProvince(); 

            resolve();
        })
    }

    const getOccupation = () => {
        return new Promise(async resolve => {
            let headers = await getHeadersAuthenLineId();
            NhealthAction.getDropdownOccupation(headers, lang)
            .then(res => {
                console.log('Occupation: ', res.data);
                if(res.IsSuccess)
                {
                    setOccupationDD(res.data);
                    resolve();
                }
            })    
        })
    }
    const getIncomPerMonth = () => {
        return new Promise(async resolve => {
            let headers = await getHeadersAuthenLineId();
            NhealthAction.getDropdownIncomePerMonth(headers, lang)
            .then(res => {
                console.log('Income Per Month: ', res.data);
                if(res.IsSuccess)
                {
                    setIncomePerMonthDD(res.data);
                    resolve();
                }
            })    
        })
    }
    const getProvince = () => {
        return new Promise(async resolve => {
            let headers = await getHeadersAuthenLineId();
            NhealthAction.getProvince(lang, headers)
            .then(res => {
                console.log('Province: ', res.data);
                if(res.IsSuccess)
                {
                    setProvinceDD(res.data);
                    resolve();
                }
            })    
        })
    }

    const nextPage = () => {
        window.location.href = `${Base_API.pathWeb}/n-health/kyc/step-4`
    };

    const openAlert = (title, body, button) => {
        let alertConfirmElem = (
            <div className="swal-cfpm">
                <div className="top">
                    <img onClick={handleCloseAlert} src="/images/icons/close-btn-2.png" />
                </div>

                <div className="mid">
                    <h2 className="title">{title}</h2>
                    <p className="desc">
                        {body}
                    </p>
                </div>

                <div className={`bottom`}>
                    <button type="button" onClick={handleCloseAlert}>
                        {button}
                    </button>
                </div>
            </div>
        );

        MySwal.fire({
            html: alertConfirmElem,
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
        });

    };

    const handleCloseAlert = () => {
        MySwal.close();
    };

    const onSkip = () => {
        location.href = `${Base_API.pathWeb}/n-health/kyc/step-4`;
    }

    const onSubmit = async(e) => {
        e.preventDefault();

        if(formValidation())
        {
            await submitForm()
            .then(() => {
                nextPage();
            })
        }
    }

    const submitForm = () => {
        return new Promise((resolve) => {
            let occupation = INPUT_OCCUPATION.current.value;
            let occupation_other = otherOccupation ? INPUT_OCCUPATION_OTHER.current.value : '';
            let income = INPUT_INCOME.current.value;
            let company_name = INPUT_COMPANY.current.value;
            let company_address = INPUT_COMPANY_ADDRESS.current.value;
            let province = INPUT_PROVINCE.current.value;
            let district = INPUT_DISTRICT.current.value;
            let subdistrict = INPUT_SUBDISTICT.current.value;
            let postcode = INPUT_POSTCODE.current.value;

            let updateKycPayload = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_UPDATE_KYC_PAYLOAD) ? DecryptedOBJ(localStorage.getItem(process.env.REACT_APP_ENC_NAME_UPDATE_KYC_PAYLOAD)) : null;             
            if(!!updateKycPayload)
            {
                let occupationData = {
                    occupation,
                    occupation_other,
                    income,
                    company_name,
                    province,
                    district,
                    subdistrict,
                    postcode,
                    company_address
                }

                let occForm = {
                    ...updateKycPayload,
                    occupation: occupationData,
                }
                occForm.occupation["company_address"] = company_address;

                localStorage.setItem(process.env.REACT_APP_ENC_NAME_UPDATE_KYC_PAYLOAD, EncryptedOBJ(occForm))

                resolve();
            }
        })
    }

    const handleChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;

        if(name === "occupation")
        {
            if(value === '0')
            {
                setOtherOccupatin(true)
            }else
            {
                setOtherOccupatin(false)
            }
        }
    }

    const formValidation = () => {
        let occupation = INPUT_OCCUPATION.current.value;
        let occupation_other = otherOccupation ? INPUT_OCCUPATION_OTHER.current.value : '';
        let income = INPUT_INCOME.current.value;
        let company_name = INPUT_COMPANY.current.value;
        let company_address = INPUT_COMPANY_ADDRESS.current.value;
        let province = INPUT_PROVINCE.current.value;
        let district = INPUT_DISTRICT.current.value;
        let subdistrict = INPUT_SUBDISTICT.current.value;
        let postcode = INPUT_POSTCODE.current.value;

        let errors = {};
        let formIsValid = true;

        // console.log('occupation: ', occupation);
        // console.log('occupation_other: ', occupation_other);
        // console.log('income: ', income);
        // console.log('company_name: ', company_name);
        // console.log('province: ', province);
        // console.log('district: ', district);
        // console.log('subdistrict: ', subdistrict);
        // console.log('postcode: ', postcode);
        
        if(occupation === 'default')
        {
            errors["occupation"] = "*กรุณาระบุอาชีพ";
            formIsValid = false;
        }
        if(otherOccupation && occupation_other.length === 0)
        {
            errors["other_occupation"] = "*กรุณากรอกอาชีพให้ครบถ้วน";
            formIsValid = false; 
        }
        if(income === 'default')
        {
            errors["income"] = "*กรุณาระบุรายได้ (รายเดือน)";
            formIsValid = false; 
        }
        if(company_name.length === 0)
        {
            errors["company_name"] = "*กรุณากรอกชื่อบริษัทให้ครบถ้วน";
            formIsValid = false; 
        }
        if(company_address.length === 0)
        {
            errors["company_address"] = "*กรุณากรอกที่อยู่บริษัทให้ครบถ้วน";
            formIsValid = false; 
        }
        if(province === 'default')
        {
            errors["province"] = "*กรุณาระบุจังหวัด";
            formIsValid = false; 
        }
        if(district === 'default')
        {
            errors["district"] = "*กรุณาระบุเขต/อำเภอ";
            formIsValid = false; 
        }
        if(subdistrict === 'default')
        {
            errors["subdistrict"] = "*กรุณาระบุแขวง/ตำบล";
            formIsValid = false; 
        }
        if(postcode === 'default')
        {
            errors["postcode"] = "*กรุณาระบุรหัสไปรษณีย์";
            formIsValid = false; 
        }

        setErrorMsg(errors);
        return formIsValid;
    }

    const onDDChange = async(e) => {
        let name = e.target.name;
        let value = e.target.value;
        isContentLoading(true);
        
        if(name === 'province')
        {
            setDistrictDD(null);
            setSubDistrictDD(null);
            setPostCodeDD(null);
            await getDistrict(value)
            isContentLoading(false);
        }else if(name === 'district')
        {
            setSubDistrictDD(null);
            setPostCodeDD(null);
            await getSubDistrict(value) 
            isContentLoading(false);
        }else if(name === 'subdistrict')
        {
            setPostCodeDD(null);
            await getPostCode(value);
            isContentLoading(false);
        }
        else
        {
            isContentLoading(false);
        }
    } 

    const getDistrict = (id) => {
        return new Promise(async resolve => {
            let headers = await getHeadersAuthenLineId();
            NhealthAction.getDistrict(lang, id, headers)
            .then(res => {
                console.log('District: ', res);
                if(res.IsSuccess)
                {
                    setDistrictDD(res.data);
                    resolve();
                }
            })
        })
    }
    const getSubDistrict = (id) => {
        return new Promise(async resolve => {
            let headers = await getHeadersAuthenLineId();
            NhealthAction.getSubdistrict(lang, id, headers)
            .then(res => {
                console.log('Sub District: ', res);
                if(res.IsSuccess)
                {
                    setSubDistrictDD(res.data);
                    resolve();
                }
            })
        })
    }
    const getPostCode = (id) => {
        return new Promise(async resolve => {
            let headers = await getHeadersAuthenLineId();
            NhealthAction.getPostalcode(lang, id, headers)
            .then(res => {
                console.log('PostCode: ', res);
                if(res.IsSuccess)
                {
                    setPostCodeDD(res.data);
                    resolve();
                }
            })
        })
    }
    
    const checkValidInput = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        console.log(value.length);

        if(name === 'company_name')
        {
            if(value.length <= 0)
            {
                setErrorMsg({ ...errorMsg, company_name: "*กรุณากรอก ชื่อบริษัท ให้ครบถ้วน" }) 
                setFormData({...formData, company_name: ""})
            }else
            {
                let cleanValue = sanitizeInput(value);
                setErrorMsg({ ...errorMsg, company_name: "" }) 
                setFormData({...formData, company_name: cleanValue})
            }
        }
        if(name === 'other_occupation')
        {
            if(value.length <= 0)
            {
                setErrorMsg({ ...errorMsg, other_occupation: "*กรุณากรอก อาชีพ ให้ครบถ้วน" }) 
                setFormData({...formData, other_occupation: ""});
            }else
            {
                let cleanValue = sanitizeInput(value);
                setErrorMsg({ ...errorMsg, other_occupation: "" }) 
                setFormData({...formData, other_occupation: cleanValue});
            }
        }
        if(name === 'company_address')
        {
            if(value.length <= 0)
            {
                setErrorMsg({ ...errorMsg, company_address: "*กรุณากรอกที่อยู่บริษัทให้ครบถ้วน" }) 
                setFormData({...formData, company_address: ""});
            }else
            {
                let cleanValue = sanitizeInput(value);
                setErrorMsg({ ...errorMsg, company_address: "" }) 
                setFormData({...formData, company_address: cleanValue});
            }
        }
    }

    function sanitizeInput(input) {
        // Replace '<' and '>' characters with their HTML entities
        const sanitized = input.replace(/</g, "").replace(/>/g, "");
        return sanitized;
    }

    return (
        <>
            <div className="kyc-step-2-con container-profile">
                <PageLoader />
                <SignIn_Navbar canClose={false} />
                <Breadcrumb_Step step={3} />

                <h3 className="header-text">
                    ข้อมูลอาชีพ
                </h3>

                <form onSubmit={onSubmit} className="form-wrap">
                    <div className="form-group" name="fname">
                        <label>โปรดเลือกแหล่งที่มาของเงินทุนของคุณ</label>
                        <div className="form-select">
                            <select 
                                name="occupation" 
                                onChange={handleChange} 
                                ref={INPUT_OCCUPATION}
                            >
                                <option value="default" id="op_blank">
                                    เลือก
                                </option>
                                {!!OccupationDD && OccupationDD.map((item, i) =>
                                    <option value={item.occupationid} key={i}>
                                        {item.occupation}
                                    </option>
                                )}
                            </select>
                            <img
                                src={ARROW_DOWN_ICON}
                                className="arrow"
                            />
                        </div>
                        <p className="input-error">
                            {errorMsg["occupation"]}
                        </p>
                    </div>
                    {otherOccupation &&
                        <div className="form-group" name="fname">
                            <input
                                type="text"
                                id="other_occupation"
                                name="other_occupation"
                                ref={INPUT_OCCUPATION_OTHER}
                                value={formData.other_occupation}
                                placeholder="กรอกอาชีพ"
                                onChange={checkValidInput}
                            />
                            <p className="input-error">
                                {errorMsg["other_occupation"]}
                            </p>
                        </div>
                    }
                    <div className="form-group" name="fname">
                        <label>รายได้ (รายเดือน)</label>
                        <div className="form-select">
                            <select name="dob" onChange={handleChange} ref={INPUT_INCOME}>
                                <option value="default" id="op_blank">
                                    เลือก
                                </option>
                                {!!incomPerMonthDD && incomPerMonthDD.map((item, i) => (
                                    <option value={item.coderef} key={i}>
                                        {item.titledata}
                                    </option>
                                ))}
                            </select>
                            <img
                                src={ARROW_DOWN_ICON}
                                className="arrow"
                            />
                        </div>
                        <p className="input-error">
                            {errorMsg["income"]}
                        </p>
                    </div>
                    <div className="form-group" name="fname">
                        <label>ชื่อบริษัท</label>
                        <input
                            type="text"
                            id="company_name"
                            name="company_name"
                            ref={INPUT_COMPANY}
                            value={formData.company_name}
                            placeholder="ชื่อบริษัท"
                            onChange={checkValidInput}
                        />
                        <p className="input-error">
                            {errorMsg["company_name"]}
                        </p>
                    </div>
                    <div className="form-group" name="fname">
                        <label>ที่อยู่บริษัท (ประเทศ)</label>
                        <input
                            type="text"
                            id="company_address"
                            name="company_address"
                            ref={INPUT_COMPANY_ADDRESS}
                            value={formData.company_address}
                            onChange={checkValidInput}
                            placeholder="ที่อยู่บริษัท"
                        />
                        <p className="input-error">
                            {errorMsg["company_address"]}
                        </p>
                    </div>
                    <div className="form-group" name="fname">
                        <label>จังหวัด</label>
                        <div className="form-select">
                            <select name="province" onChange={onDDChange} ref={INPUT_PROVINCE}>
                                <option value="default" id="op_blank">
                                    เลือก
                                </option>
                                {!!provinceDD && provinceDD.map((item, i) => (
                                    <option value={item.coderef} key={i}>
                                        {item.titledata}
                                    </option>
                                ))}
                            </select>
                            <img
                                src={ARROW_DOWN_ICON}
                                className="arrow"
                            />
                        </div>
                        <p className="input-error">
                            {errorMsg["province"]}
                        </p>
                    </div>
                    <div className={`form-group`} name="fname">
                        <label>เขต/อำเภอ</label>
                        <div className="form-select">
                            <select name="district" onChange={onDDChange} ref={INPUT_DISTRICT}>
                                <option value="default" id="op_blank">
                                    เลือก
                                </option>
                                {!!districtDD && districtDD.map((item, i) => (
                                    <option value={item.coderef} key={i}>
                                        {item.titledata}
                                    </option>
                                ))}
                            </select>
                            <img
                                src={ARROW_DOWN_ICON}
                                className="arrow"
                            />
                        </div>
                        <p className="input-error">
                            {errorMsg["district"]}
                        </p>
                    </div>
                    <div className={`form-group`} name="fname">
                        <label>แขวง/ตำบล</label>
                        <div className="form-select">
                            <select name="subdistrict" onChange={onDDChange} ref={INPUT_SUBDISTICT}>
                                <option value="default" id="op_blank">
                                    เลือก
                                </option>
                                {!!subDistrictDD && subDistrictDD.map((item, i) => (
                                    <option value={item.coderef} key={i}>
                                        {item.titledata}
                                    </option>
                                ))}
                            </select>
                            <img
                                src={ARROW_DOWN_ICON}
                                className="arrow"
                            />
                        </div>
                        <p className="input-error">
                            {errorMsg["subdistrict"]}
                        </p>
                    </div>
                    <div className="form-group" name="fname">
                        <label>รหัสไปรษณีย์</label>
                        <div className="form-select">
                            <select name="postcode" onChange={onDDChange} ref={INPUT_POSTCODE}>
                                <option value="default" id="op_blank">
                                    เลือก
                                </option>
                                {!!postCodeDD && postCodeDD.map((item, i) => (
                                    <option value={item.coderef} key={i}>
                                        {item.titledata}
                                    </option>
                                ))}
                            </select>
                            <img
                                src={ARROW_DOWN_ICON}
                                className="arrow"
                            />
                        </div>                    
                        <p className="input-error">
                            {errorMsg["postcode"]}
                        </p>
                    </div>
                    {/* <div className="form-group">
                        <label htmlFor='confirm' className="top">
                            <input type="checkbox" id="confirm" />
                            <label htmlFor='confirm'>ที่อยู่ที่สะดวกในการติดต่อ <br/> แตกต่างจากที่อยู่ตามบัตรประชาชน</label>
                        </label>
                    </div> */}


                    {/* <button 
                        className={`btn-save`} type="button" 
                        // onClick={onSubmit}
                        onClick={onSkip}
                    >
                        บันทึกข้อมูล
                    </button> */}
                    <button
                        className={`btn-submit`} type="submit"
                        onClick={onSubmit}
                        // onClick={onSkip}
                    >
                        ดำเนินการต่อ
                    </button>
                </form>
                {/* <PrivacyPolicy /> */}
            </div>
            <ContentLoader />
        </>
    );
}
